module.exports = __webpack_public_path__ + "img/plan.fc139b28.jpg";